import * as types from './actionTypes';

const initialState = {
  job_setup_qualifications: [],
  loading: false,
  error: null,
  success: false,
};

const qualificationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_JOB_SETUP_QUALIFICATIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };

    case types.FETCH_JOB_SETUP_QUALIFICATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        job_setup_qualifications: action.payload.data || [],
        success: false,
      };

    case types.FETCH_JOB_SETUP_QUALIFICATIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };

    case types.SAVE_JOB_SETUP_QUALIFICATION_REQUEST:
      return {
        ...state,
        error: null,
        success: false,
      };

    case types.SAVE_JOB_SETUP_QUALIFICATION_SUCCESS:
      return {
        ...state,
        success: true,
      };

    case types.SAVE_JOB_SETUP_QUALIFICATION_FAILURE:
      return {
        ...state,
        error: action.payload,
        success: false,
      };

      case types.CHANGE_JOB_SETUP_QUALIFICATION_STATUS_REQUEST:
        return {
          ...state,
          error: null,
          success: false,
        };
  
      case types.CHANGE_JOB_SETUP_QUALIFICATION_STATUS_SUCCESS:
        return {
          ...state,
          success: true,
        };
  
      case types.CHANGE_JOB_SETUP_QUALIFICATION_STATUS_FAILURE:
        return {
          ...state,
          error: action.payload,
          success: false,
        };

    default:
      return state;
  }
};

export default qualificationsReducer;
